import { c as _c } from "react/compiler-runtime";
import { Stack, Avatar, Heading, HStack, Separator, Wrap, Badge, ProgressCircle, Text, Flex, AbsoluteCenter } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type RequestMatchExampleCardProps = {
  tags: string[];
  name: string;
  investorType: string;
  location: string;
  matchScore: number;
};
export const RequestMatchExampleCard = props => {
  const $ = _c(30);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? "start" : "center";
  const t1 = isMobile ? "column" : "row";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Avatar.Root bgColor="colorPalette.solid" borderRadius="md" size="sm"><Avatar.Fallback borderRadius="md" /></Avatar.Root>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== props.name) {
    t3 = <Heading size="sm">{props.name}</Heading>;
    $[1] = props.name;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props.investorType) {
    t4 = <Text color="colorPalette.fg" fontSize="xs">{props.investorType}</Text>;
    $[3] = props.investorType;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Separator borderWidth={1} height="12px" orientation="vertical" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props.location) {
    t6 = <Text color="colorPalette.fg" fontSize="xs">{props.location}</Text>;
    $[6] = props.location;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <HStack gap={1}>{t4}{t5}{t6}</HStack>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <Stack align="center" direction="row" gap={2} justify="center" padding={2} width="full">{t2}<Stack align="start" direction="column" gap={0} justify="start" width="full">{t3}{t7}</Stack></Stack>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== props.tags) {
    t9 = props.tags.map(_temp);
    $[14] = props.tags;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <Wrap align="center" direction="row" gap={1} justify="end">{t9}</Wrap>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t10 || $[21] !== t8) {
    t11 = <Stack align={t0} direction={t1} gap={2} justify="center" padding={2} width="full">{t8}{t10}</Stack>;
    $[18] = t0;
    $[19] = t1;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ProgressCircle.Circle css={{
      "--thickness": "4px"
    }}><ProgressCircle.Track /><ProgressCircle.Range strokeLinecap="round" /></ProgressCircle.Circle>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AbsoluteCenter><ProgressCircle.ValueText /></AbsoluteCenter>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== props.matchScore) {
    t14 = <Flex align="center" alignSelf="stretch" bgColor="colorPalette.card/20" justify="center" padding={2}><ProgressCircle.Root colorPalette="teal" size="lg" value={props.matchScore}>{t12}{t13}</ProgressCircle.Root></Flex>;
    $[25] = props.matchScore;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t11 || $[28] !== t14) {
    t15 = <Stack align="center" background="colorPalette.container" borderRadius="lg" boxShadow="lg" direction="row" gap={0} justify="start" overflow="hidden" padding={0} width="full">{t11}{t14}</Stack>;
    $[27] = t11;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
function _temp(tag, i) {
  return <Badge key={i} backgroundColor="colorPalette.card/50" border="none" borderRadius="sm" boxShadow="none" color="colorPalette.fg" fontSize="8px" fontWeight="600" letterSpacing="0.05em" lineHeight="1" overflow="hidden" padding={1} textAlign="center" textOverflow="ellipsis" textTransform="uppercase" variant="subtle" whiteSpace="nowrap">{tag}</Badge>;
}